import cx from 'clsx';

import { PlainModal } from '@/components/modals/plain-modal';
import { TextLink } from '@/components/text-link';
import { joinSgcmSite } from '@/utils/url/join/public';

import { MODAL_TITLE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const ArfModal: Component = ({
  isOpen,
  onClose,
}) => (
  <PlainModal
    className={styles.containerArfModal}
    isOpen={isOpen}
    modalTitle={MODAL_TITLE}
    onClose={onClose}>
    <div>
      The Additional Registration Fee (ARF) is a tax imposed upon
      registration of a vehicle. It is calculated based on a percentage
      of the Open Market Value (OMV) of the vehicle.
    </div>
    <div>
      The ARF determines your PARF rebate which is a component of your
      de-registration value.
    </div>
    <div>
      [COE rebate + PARF rebate] = De-registration value
    </div>
    <div>
      Read more about the
      <TextLink
        className={styles.textLink}
        href={`${joinSgcmSite('/articles/advice/understanding-omv-parf-and-coe-rebates-for-your-car-30522')}`}
        target="_blank"
        text="  LTA PARF rebate scheme" />
      .
    </div>
    <div className={styles.containerTable}>
      <div
        className={cx(styles.containerItem, styles.textTableHeader)}>
        Age of vehicle
      </div>
      <div
        className={cx(styles.containerItem, styles.textTableHeader)}>
        PARF Rebate
      </div>
      <div className={styles.containerItem}>
        Not more than 5 years
      </div>
      <div className={styles.containerItem}>
        75% of ARF paid or $60,000 (whichever is lower)
      </div>
      <div className={styles.containerItem}>
        Above 5 but not more than 6 years
      </div>
      <div className={styles.containerItem}>
        70% of ARF paid or $60,000 (whichever is lower)
      </div>
      <div className={styles.containerItem}>
        Above 6 but not more than 7 years
      </div>
      <div className={styles.containerItem}>
        65% of ARF paid or $60,000 (whichever is lower)
      </div>
      <div className={styles.containerItem}>
        Above 7 but not more than 8 years
      </div>
      <div className={styles.containerItem}>
        60% of ARF paid or $60,000 (whichever is lower)
      </div>
      <div className={styles.containerItem}>
        Above 8 but not more than 9 years
      </div>
      <div className={styles.containerItem}>
        55% of ARF paid or $60,000 (whichever is lower)
      </div>
      <div className={styles.containerItem}>
        Above 9 but not more than 10 years
      </div>
      <div className={styles.containerItem}>
        50% of ARF paid or $60,000 (whichever is lower)
      </div>
      <div className={styles.containerItem}>
        More than 10 years
      </div>
      <div className={styles.containerItem}>
        Nil
      </div>
    </div>
    <div>
      Below shows ARF calculations for cars registered
      with COEs obtained from Feb 2022 onward.
    </div>
    <div className={styles.containerTable}>
      <div
        className={cx(styles.containerItem, styles.textTableHeader)}>
        Vehicle OMV
      </div>
      <div
        className={cx(styles.containerItem, styles.textTableHeader)}>
        ARF Rate
      </div>
      <div className={styles.containerItem}>
        First $20,000 of OMV
      </div>
      <div className={styles.containerItem}>
        100% of OMV
      </div>
      <div className={styles.containerItem}>
        Next $20,000 of OMV (i.e. $20,001 to $40,000)
      </div>
      <div className={styles.containerItem}>
        140% of OMV
      </div>
      <div className={styles.containerItem}>
        [NEW] Next $20,000 of OMV (i.e. $40,001 to $60,000)
      </div>
      <div className={styles.containerItem}>
        190% of OMV
      </div>
      <div className={styles.containerItem}>
        [NEW] Next $20,000 of OMV (i.e. $60,001 to $80,000)
      </div>
      <div className={styles.containerItem}>
        250% of OMV
      </div>
      <div className={styles.containerItem}>
        [NEW] Above $80,000 of OMV (i.e. $80,001 and above)
      </div>
      <div className={styles.containerItem}>
        320% of OMV
      </div>
    </div>
    <div>
      <TextLink
        className={styles.textLink}
        href={`${joinSgcmSite('/articles/news/new-carbon-emissions-based-vehicle-scheme-cevs-kicking-in-from-january-2013-9176')}`}
        target="_blank"
        text="VES" />
      {' '}
      rebates (if any) will be subtracted off from the above values.
    </div>
    <div className={styles.textSubtitle}>Calculation for ARF:</div>
    <ol className={styles.orderList}>
      <li className={styles.textLi}>
        For cars with OMV below $20K:
        <div>OMV - VES rebates = ARF</div>
      </li>
      <li className={styles.textLi}>
        For cars with OMV between $20,001 to $40,000:
        <div>[(OMV - 20000) x 140%] + 20000 = X</div>
        <div>X - VES rebate = ARF</div>
      </li>
      <li className={styles.textLi}>
        For cars with OMV between $40,001 to $60,000:
        <div>[(OMV - 40000) x 190%] + 48000 = X</div>
        <br />
        <div>X - VES rebate = ARF</div>
      </li>
      <li className={styles.textLi}>
        For cars with OMV above $60,001 to $80,000:
        <div>[(OMV - 60000) x 250%] + 86000 = X</div>
        <br />
        <div>X - VES rebate = ARF</div>
      </li>
      <li className={styles.textLi}>
        For cars with OMV above $80,001:
        <div>[(OMV - 80000) x 320%] + 136000 = X</div>
        <br />
        <div>X - VES rebate = ARF</div>
      </li>
    </ol>
    <br />
  </PlainModal>
);
